import {
    HTTP_BAD_REQUEST,
    HTTP_FORBIDDEN,
    HTTP_INTERNAL_SERVER,
    HTTP_NOT_FOUND,
    HTTP_UNAUTHORIZED,
    HTTP_UNPROCESSABLE_ENTITY,
    HttpError
} from "./http.error";
import ServerError from "./server.error";
import ClientError from "./client.error";
import BadRequestError from "./badrequest.error";
import UnauthorizedError from "./unauthorized.error";
import ForbiddenError from "./forbidden.error";
import NotFoundError from "./notfound.error";
import UnprocessableEntityError from "./unprocessableentity.error";

export default class HttpErrorFactory {
    /**
     * Factory
     * @param statusCode {int}
     * @param message {string}
     * @param response {*}
     * @param previous {Error}
     * @returns {HttpError|ServerError|ClientError|BadRequestError|UnprocessableEntityError|ForbiddenError|UnauthorizedError|NotFoundError}
     */
    static instance(statusCode, message, response, previous) {
        if (statusCode >= HTTP_INTERNAL_SERVER) {
            return new ServerError(statusCode, message, response, previous);
        }
        if (statusCode >= HTTP_BAD_REQUEST) {
            switch (statusCode) {
                case HTTP_BAD_REQUEST:
                    return new BadRequestError(message, response, previous);
                case HTTP_UNAUTHORIZED:
                    return new UnauthorizedError(message, response, previous);
                case HTTP_FORBIDDEN:
                    return new ForbiddenError(message, response, previous);
                case HTTP_NOT_FOUND:
                    return new NotFoundError(message, response, previous);
                case HTTP_UNPROCESSABLE_ENTITY:
                    return new UnprocessableEntityError(message, response, previous);
                default:
                    return new ClientError(statusCode, message, response, previous);
            }
        }
        return new HttpError(statusCode, message, response, previous);
    }

    static axios(error) {
        if (
            typeof error.response !== 'undefined'
            && typeof error.response.status !== 'undefined'
        ) {
            return HttpErrorFactory.instance(
                error.response.status,
                error.response.statusText || 'Error',
                error.response,
                error
            );
        }
        return error;
    }
}